// extracted by mini-css-extract-plugin
export default {"tooltip-container":"Tooltip_tooltip-container__EkmDU"};